import {Injectable} from '@angular/core';
import {LocalStorageService, SessionStorageService, UrlService} from '@dcp/configurator';

@Injectable({
  providedIn: 'root',
})
export class UrlStorageService {
  constructor(
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private urlService: UrlService
  ) {}

  storeValidUrlInLocalStorage(key: string, url: string): boolean {
    const isUrlValid = this.isValid(url);
    if (isUrlValid) {
      this.localStorageService.setItem(key, url);
      return true;
    }
    this.localStorageService.removeItem(key);
    return false;
  }

  storeValidUrlInSessionStorage(key: string, url: string): boolean {
    const isUrlValid = this.isValid(url);
    if (isUrlValid) {
      this.sessionStorageService.setItem(key, url);
      return true;
    }
    this.sessionStorageService.removeItem(key);
    return false;
  }

  isValid(url: string): boolean {
    return (
      !!url &&
      url.startsWith('https://') &&
      !!this.urlService.sanitizeUrl(url) &&
      this.urlService.isURLDomainTrusted(url)
    );
  }
}
